import { Routes, Route, useLocation } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { LoginPage } from './pages/LoginPage';
import { PasswordResetPage } from './pages/PasswordResetPage';
import { ApplicationPage } from './pages/ApplicationPage';
import { ApplicationSuccessPage } from './pages/ApplicationSuccessPage';
import { MemberDashboardPage } from './pages/MemberDashboardPage';
import { MemberProfilePage } from './pages/MemberProfilePage';
import { SettingsPage } from './pages/SettingsPage';
import { ContributionPage } from './pages/ContributionPage';
import { ContributionHistoryPage } from './pages/ContributionHistoryPage';
import './App.css';
import { clsx } from 'clsx';
import { PublicOnlyRoute, RequireAuth } from './routes';

function App() {
  const location = useLocation();
  const hideFooter = location.pathname.startsWith('/dashboard') || location.pathname.startsWith('/profile') || location.pathname.startsWith('/contribution') || location.pathname.startsWith('/history') || location.pathname.startsWith('/settings');
  const isAuthRoute = ['/login', '/reset-password', '/apply', '/apply/success'].some((path) => location.pathname.startsWith(path));

  return (
    <div
      className={clsx(
        'flex min-h-screen flex-col text-slate-900 transition-colors duration-300 dark:text-slate-100',
        isAuthRoute ? 'bg-slate-900 dark:bg-slate-950' : 'bg-slate-100 dark:bg-slate-950'
      )}
    >
      {!isAuthRoute && <Header />}
      <main
        className={clsx(
          'flex-1 transition-colors duration-300',
          isAuthRoute ? 'bg-slate-900 text-white dark:bg-slate-950' : 'bg-white dark:bg-slate-900'
        )}
      >
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route element={<PublicOnlyRoute />}>
            <Route path="/login" element={<LoginPage />} />
          </Route>
          <Route path="/reset-password" element={<PasswordResetPage />} />
          <Route path="/apply" element={<ApplicationPage />} />
          <Route path="/apply/success" element={<ApplicationSuccessPage />} />
          <Route element={<RequireAuth />}>
            <Route path="/dashboard" element={<MemberDashboardPage />} />
            <Route path="/profile" element={<MemberProfilePage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/contribution" element={<ContributionPage />} />
            <Route path="/history" element={<ContributionHistoryPage />} />
          </Route>
        </Routes>
      </main>
      {!hideFooter && !isAuthRoute && <Footer />}
    </div>
  );
}

export default App;
